import React, {Component} from 'react';
import I18n from 'app/i18n';
import {translatedName} from 'app/utils/translations_helper';
import {SimpleArtifactImage} from 'app/components/my_profile/artifacts/image';
import {inject, observer} from 'mobx-react';
import BuyButton from 'app/components/shop/lootboxes/buy_button';
import {isGuest, scrollToTop} from 'app/utils';
import LootboxItem from './lootbox_item';
import {lootboxUse} from 'app/utils/lootbox_open/lootbox_use';
import {openPopupClickable} from 'app/components/my_profile/hero/clickable';
import NotificationStore from 'app/store/notifications';
import {OPEN_LOOTBOX_UPDATE_TIMEOUT, DELAY_BEFORE_OPENING_LOOTBOX} from 'app/store/ArtifactStore';
import {toastError} from 'app/components/toasts/liteToast';
import {currencyItem} from 'app/utils/ShopItemPriceFormat';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';
import withRouter from 'app/utils/navigate/customWithRouter';
import GoBackButton from 'app/components/reusable/GoBackButton';
import {updateInfo} from 'app/common';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {coolOffLootbox} from 'app/utils/isCoolOffActiveFor';
import {casinoGamesStore, userBonusesStore} from 'app/store/global';
import {ELEMENT_NOT_FOUND} from 'app/utils/Consts';
import {goToCasino} from 'app/utils/app_links';


class LootboxDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idTimerShowPrize: null,
            loading: true,
            lootboxOpeningProcess: false
        };
        this.loadShopLootbox = this.loadShopLootbox.bind(this);
    }

    componentDidMount() {
        this.loadShopLootbox();

        if (!this.props.skipScrollToTop) {
            scrollToTop();
        }

        const {shopLootboxStore} = this.props;

        if (shopLootboxStore.openNowLootbox) {
            setTimeout(this.open, DELAY_BEFORE_OPENING_LOOTBOX);
            shopLootboxStore.updateOpenNowStatus(false);
            shopLootboxStore.updateBuyAndOpenNowStatus(false);
        }
    }

    componentWillUnmount() {
        const {idTimerShowPrize, lootboxOpeningProcess} = this.state;
        const {shopLootboxStore} = this.props;
        shopLootboxStore.updateLootbox({lootbox: null});
        shopLootboxStore.updateAnimationStatus(true);
        shopLootboxStore.updateOpenNowStatus(false);
        shopLootboxStore.updateLootboxOpeningInProgress(false);
        shopLootboxStore.setReturnToCasinoAllGamesOnLootboxBack(false);

        if (idTimerShowPrize) {
            clearTimeout(idTimerShowPrize);
        }
        if (lootboxOpeningProcess) {
            NotificationStore.add({
                type: 'leave_lootbox_page'
            });
        }
    }

    componentDidUpdate(props) {
        const {shopLootboxStore} = this.props;

        if (this.props.params.name !== props.params.name) {
            this.loadShopLootbox();
        }
        if (shopLootboxStore.openNowLootbox) {
            this.loadShopLootbox();
            setTimeout(this.open, DELAY_BEFORE_OPENING_LOOTBOX);
            shopLootboxStore.updateOpenNowStatus(false);
            shopLootboxStore.updateBuyAndOpenNowStatus(false);
        }
    }

    get currency() {
        return new URLSearchParams(location.search).get('currency');
    }

    async loadShopLootbox() {
        const {shopLootboxStore, params: {name}} = this.props;
        await shopLootboxStore.updateLootboxBySlug(name, this.currency);
        this.setState({loading: false});
    }

    afterBuy = () => {
        this.loadShopLootbox();
        setTimeout(this.open, DELAY_BEFORE_OPENING_LOOTBOX);
    };

    loaderStart = () => {
        const {shopLootboxStore} = this.props;
        this.setState({lootboxOpeningProcess: true});
        shopLootboxStore.updateLootboxOpeningInProgress(true);
        setTimeout(() => {
            this.setState({lootboxOpeningProcess: false});
            shopLootboxStore.updateLootboxOpeningInProgress(false);
            updateInfo();
        }, OPEN_LOOTBOX_UPDATE_TIMEOUT);
    };

    open = () => {
        const {lootbox: {lootbox_to_open, user_lootbox_count}} = this.props.shopLootboxStore;
        const {lootboxOpeningProcess} = this.state;

        if (lootboxOpeningProcess || user_lootbox_count === 0) {
            return;
        }
        if (lootbox_to_open) {
            this.loaderStart();
            lootboxUse(lootbox_to_open, {
                doneOpenHandler: this.doneOpenHandler,
                show_loading: false,
                timeStart: Date.now()
            });
        } else {
            toastError(I18n.t('server_error_try_later'));
        }
    };

    doneOpenHandler = (artifact, response, params) => {
        const {timeStart} = params;
        const {
            extra_data,
            steam_skin,
            steam_trade,
            win_artifact
        } = response;
        this.loadShopLootbox();
        this.setState({
            idTimerShowPrize: setTimeout(
                () => openPopupClickable(artifact, true, {
                    extra_data,
                    onLootboxPrizePopupClose: () => {
                        userBonusesStore.showNotViewedBonusPopup(true);
                    },
                    steam_skin,
                    steam_trade,
                    win_artifact
                }),
                timeStart + OPEN_LOOTBOX_UPDATE_TIMEOUT - Date.now()
            )
        });
    };

    get showButtonOpenFromInventory() {
        return !isGuest() && !this.state.lootboxOpeningProcess;
    }

    coolOffLootboxesDisabled = () => {
        const {userStore: {user}} = this.props;
        return coolOffLootbox(user);
    };

    handleGoBackFromCasino = () => {
        const {shopLootboxStore} = this.props;
        shopLootboxStore.setReturnToCasinoAllGamesOnLootboxBack(false);
        casinoGamesStore.changeFilterGroup(ELEMENT_NOT_FOUND);
        goToCasino();
    };

    render() {
        const {isCasinoPage, shopLootboxStore} = this.props;
        const {lootbox, animationLootboxFromOtherPage, buyAndOpenNowLootbox, updateAnimationStatus,
            animationOpenEnd, returnToCasinoAllGamesOnLootboxBack} = shopLootboxStore;
        const {lootboxOpeningProcess} = this.state;

        if (this.state.loading) {
            return <SmartFullPageLoader/>;
        }

        if (!lootbox) {
            return null;
        }

        const {recipe, user_lootbox_count} = lootbox;
        const useCasinoAllGamesBack = isCasinoPage && returnToCasinoAllGamesOnLootboxBack;

        return <div className="market-details">
            <div className="market-details--info">
                <div className="market-details--info--content">
                    <div className="market-details--top with--border">
                        <GoBackButton
                            {...(useCasinoAllGamesBack ? {onClick: this.handleGoBackFromCasino} : {})}
                        />
                        <h1 className="market-details--info--desc-name">{translatedName(recipe)}</h1>
                    </div>
                    <div className="market-details--info--description">
                        <div className="market-details--info--img-wrap">
                            <div className="market-details--info--img">
                                <div className="market-details--info--inner--img">
                                    <SimpleArtifactImage artifact={recipe}/>
                                    <div className={`market-details--number-boxes ${
                                        user_lootbox_count && !(lootboxOpeningProcess || animationLootboxFromOtherPage) ? '' : 'hidden'}`}>
                                        <SpriteIcon size="#svg-number-boxes" className="icon"/>
                                        <span className="number-value">{user_lootbox_count}</span>
                                    </div>
                                    <div
                                        className={`market-details--loader ${
                                           lootboxOpeningProcess || animationLootboxFromOtherPage ? 'active' : ''
                                        }`}
                                    >
                                        <div className="loader-line-box ">
                                            <span className="loader-line">
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="market-details--group-buttons">
                                {!isGuest() && <BuyButton
                                    {...lootbox}
                                    currency={currencyItem(this.currency)}
                                    lootboxOpeningProcess={lootboxOpeningProcess || animationLootboxFromOtherPage}
                                    customText={I18n.t('buy')}
                                    buyNow={buyAndOpenNowLootbox}
                                    afterBuy={this.afterBuy}
                                    show_loading={false}
                                    disabled={this.coolOffLootboxesDisabled()}
                                />}
                                {this.showButtonOpenFromInventory && !animationLootboxFromOtherPage && <button
                                    className={`button-adaptive ${
                                        user_lootbox_count
                                            ? 'btn-open'
                                            : 'button-adaptive_disable'
                                    }`}
                                    disabled={!user_lootbox_count || this.coolOffLootboxesDisabled()}
                                    onClick={this.open}
                                >
                                    {I18n.t('open')}
                                </button>}
                            </div>
                        </div>
                        <div className="market-details--info--desc">
                            <div className="market-details--info--desc-title gray-title">
                                <span className="icon-title">
                                    <SpriteIcon name="#svg-gold-cup"/>
                                </span>
                                {I18n.t('you_may_win')}
                            </div>
                            <div className="market-details--info--desc-text">
                                <LootboxItem
                                    {...recipe}
                                    lootboxOpeningProcess={lootboxOpeningProcess}
                                    animationOpenEnd={animationOpenEnd}
                                    updateAnimationStatus={updateAnimationStatus}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default withRouter(inject('shopLootboxStore', 'userStore')(observer(LootboxDetails)));
